import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resendPasswordResetEmail } from '../redux/modules/user/actions';
import CommonAuthComponent from './CommonAuthComponent';
import emailBoxIcon from '/icons/email-box.svg';

const CheckYourEmail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { resendEmailLoading } = useSelector((state) => state.users);
  const email = location.state?.email || 'your email address';

  const handleResendEmail = async () => {
    // Only resend and show toast; do not navigate away from this page
    dispatch(resendPasswordResetEmail(email));
  };

  return (
    <CommonAuthComponent maxWidthClass="max-w-md">
      <div className="flex flex-col items-center">

        {/* Email Icon */}
        <div className="flex items-center justify-center">
          <img
            src={emailBoxIcon}
            alt="Session Expired"
            className="h-[80px] w-[80px]"
          />
        </div>

        {/* Heading */}
        <h1 className="text-[22px] text-center font-medium leading-[30px] mt-[20px] mb-[10px]">
          Check Your Email
        </h1>


        {/* Instruction Text */}
        <p className="text-center text-[16px] font-normal !mb-[46px] leading-[22px]">
          <span>Please check the email address</span>
          <br />
          <span className="font-bold">{email}</span>
          <br />
          <span>for instructions to reset your password.</span>
        </p>

        {/* Resend Email Button */}
        <button
          onClick={handleResendEmail}
          disabled={resendEmailLoading}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5
            bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
        >
          {resendEmailLoading ? (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : null}
          {resendEmailLoading ? 'Sending...' : 'Resend Email'}
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default CheckYourEmail;
